import {LanguageResource} from '@/common/api/api-raw-types';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';

export class LanguagesService {
    private allLanguagesCache: Promise<HttpServiceResponse<LanguageResource[]>> | null = null;

    private async fetchAllLanguages(): Promise<HttpServiceResponse<LanguageResource[]>> {
        return await context.httpService.get(context.registry.entries.languages());
    }

    async getAllLanguages(): Promise<HttpServiceResponse<LanguageResource[]>> {
        if (!this.allLanguagesCache) {
            this.allLanguagesCache = this.fetchAllLanguages();
        }

        const [allLanguages, error] = await this.allLanguagesCache;
        if (error || !allLanguages) {
            this.allLanguagesCache = null;
            return [null, error];
        }

        return [allLanguages, null];
    }

    async search(query: string): Promise<HttpServiceResponse<LanguageResource[]>> {
        const [allLanguages, error] = await this.getAllLanguages();

        if (error || !allLanguages) {
            return [null, error];
        }

        const result = allLanguages.filter((language) => language.label.toLowerCase().startsWith(query.toLowerCase()));
        return [result, null];
    }
}
